/* eslint-disable */
//tslint:disable

export interface IDayOfWeekScheduleSchema {
  /**  Звонить с  **/
  callFrom?: string | null;
  /**  Звонить до  **/
  callTo?: string | null;
  /**  День недели  **/
  day: EDay;
  /**  Является ли день рабочим  **/
  isWorkingDay: boolean;
}

export enum EDay {
  /** Пятница **/
  Friday = 'Friday',
  /** Понедельник **/
  Monday = 'Monday',
  /** Суббота **/
  Saturday = 'Saturday',
  /** Воскресенье **/
  Sunday = 'Sunday',
  /** Четверг **/
  Thursday = 'Thursday',
  /** Вторник **/
  Tuesday = 'Tuesday',
  /** Среда **/
  Wednesday = 'Wednesday',
}
